
import Vue from 'vue';
import VRuntimeTemplate from 'v-runtime-template';
export default Vue.extend({
  components: {
    VRuntimeTemplate,
  },
  props: {
    data: {
      type: String,
      required: true,
    },
  },
  computed: {
    compiledTemplate(): string {
      let template = this.data.replace(/a href/g, 'a rel="noopener noreferrer" href');

      /**
       * Ensure links with fragment IDs have a trailing slash before the '#'.
       * This is important to align with the trailing slash behavior in Nuxt routing
       * and ensures that in-page anchor links work correctly.
       */
      template = template.replace(/href=(['"])([^'"]+)\1/gm, (_match, quote, href) => {
        if (!href.includes('#')) {
          return `href=${quote}${href}${quote}`;
        }

        const [base, ...fragmentParts] = href.split('#');
        const fragment = fragmentParts.join('#');

        if (!base || !fragment || base.endsWith('/')) {
          return `href=${quote}${href}${quote}`;
        }
        return `href=${quote}${base}/#${fragment}${quote}`;
      });

      // Add keys to components that will update dynamically since they lack data
      template = template.replace(/v-bind='{"uid":"([\d\w-]+)"}'/gm, `v-bind='{"key":"$1","uid":"$1"}'`);
      return template;
    },
  },
});
